export default "__VITE_ASSET__BXE2Upbl__"